import { Gender } from './generated';

export enum Expertise {
  BIG_TALL = 'BIG & TALL DRESSING',
  BLACK_TIE = 'BLACK TIE & RED CARPET EVENTS',
  BRIDAL = 'BRIDAL STYLING',
  BUSINESS_TRAVEL = 'BUSINESS TRAVEL WARDROBE',
  CAPSULE_WARDROBE = 'CAPSULE WARDROBE BUILDING',
  CARRY_ON = 'CARRY-ON ONLY STYLING',
  CLOSET_EDIT = 'CLOSET EDIT & ORGANIZATION',
  DATE_NIGHT = 'DATE NIGHT LOOKS',
  DESTINATION = 'DESTINATION-SPECIFIC STYLING',
  EDITORIAL = 'EDITORIAL & PHOTOSHOOT STYLING',
  EVERYDAY = 'EVERYDAY STYLING',
  MATERNITY = 'MATERNITY & POSTPARTUM',
  MODEST = 'MODEST STYLING',
  PETITE = 'PETITE STYLING',
  PLUS_SIZE = 'PLUS SIZE STYLING',
  SPORT = 'SPORT & LEISURE STYLING',
  STREET_STYLE = 'STREET STYLE LOOKS',
  TV_FILM_MEDIA = 'TV, FILM, MEDIA WARDROBE',
  VACATION = 'VACATION & RESORT WEAR',
  VINTAGE = 'VINTAGE DRESSING',
  WORK_OUTFITS = 'WORKWEAR & POWER DRESSING',
  WEDDING_GUEST = 'WEDDING GUEST STYLING',
}

export enum StylingPreference {
  BOHEMIAN = 'BOHEMIAN',
  FEMININE = 'FEMININE',
  GRUNGE = 'GRUNGE',
  MAXIMALIST = 'MAXIMALIST',
  MINIMALIST = 'MINIMALIST',
  CLASSIC = 'TIMELESS & CLASSIC',
  TRENDY = 'TREND-FORWARD',
  STREETWEAR = 'STREETWEAR',
  ATHLEISURE = 'SPORTY & ATHLEISURE',
  VINTAGE = 'VINTAGE',
}

export interface ProfileFormData {
  firstName: string;
  lastName: string;
  gender?: Gender | null;
  birthDate?: Date;
  profileImage: string;
  maskedPhoneNumber?: string;
  phoneNumber?: string;
  isCheckBoxChecked: boolean;
  signNowDocumentId?: string;
  shareAge?: boolean;
}

export type ProfileFormDataWithoutCheckBox = Omit<
  ProfileFormData,
  'isCheckBoxChecked'
>;

export interface BioData {
  bio: string;
  tikTok: string;
  instagram: string;
  substack: string;
}

export interface GalleryImages {
  landscapeImage: string | null;
  portraitImages: string[];
}

export interface ClientMeasurements {
  sizingDetails: string;
  height: string;
}

export interface SavedFormValues {
  profileFormData: ProfileFormDataWithoutCheckBox;
  bioData: BioData;
  clientMeasurements: ClientMeasurements;
  selectedExpertise: string[];
  selectedStylingPreference: string[];
  galleryImages: GalleryImages;
}

export interface StylistFavorite {
  id: number;
  clientId: number;
  stylistId: number;
  createdAt: Date;
}

export interface ToggleStylistFavoriteInput {
  stylistId: number;
}

export interface StylistWithFavoriteStatus {
  id: number;
  bio: string;
  landscapeImage: string | null;
  portraitImages: string[];
  expertise: string[];
  aesthetics: string[];
  hasCompletedStripeSetup: boolean;
  tiktok?: string | null;
  instagram?: string | null;
  stripeAccountId?: string | null;
  customHourlyRate?: number | null;
  isFavorited: boolean;
  user?: {
    id: number;
    firstName: string;
    lastName: string;
    profilePicUrl: string;
    gender?: Gender | null;
  };
  pricing?: {
    id: number;
    tierName: string;
    hourlyRate: number;
  };
}

export interface FavoritesFilterState {
  showFavoritesOnly: boolean;
}
